var valueFormat = 'YYYY-MM-DD';

module.directive('calendar', function(moment) {
    return {
        restrict: 'E',
        require: '?ngModel',
        templateUrl: 'util/dates/calendar',
        scope: {
            dateSelected: '&',
        },
        link: function(scope, element, attrs, ngModel) {
            if (!ngModel) return;

            scope.viewDate = moment();
            scope.context = "days";

            scope.months = moment.monthsShort();

            scope.data = {};

            scope.$watch("viewDate.format('YYYYMM')", function(newVal, oldVal) {
                newVal = moment(newVal, 'YYYYMM');
                oldVal = moment(oldVal, 'YYYYMM');
                scope.days = getDaysForDate(newVal);
                if (!scope.years || !newVal.isSame(oldVal, 'year')) {
                    scope.years = getYearsForDate(newVal);
                }
            });

            function setViewToDate(date) {
                if (!date || !date.isValid()) {
                    date = moment();
                }
                scope.viewDate = moment(date);
            }

            function getDaysForDate(date) {
                var days = [];
                var start_date = moment(date).startOf('month').days(0);
                var end_date = moment(date).endOf('month').days(6);

                for (var d = start_date; d.isBefore(end_date); d.add(1, 'day')) {
                    days.push(moment(d));
                }
                return days;
            }

            function getYearsForDate(date) {
                var years = [];
                for (var i = 0; i < 20; i++) {
                    years.push(date.year() + i - 10);
                }
                return years;
            }

            scope.dateClasses = function(date) {
                return {
                    'diff-month': ! date.isSame(scope.viewDate, 'month'),
                    today: date.isSame(undefined, 'day'),
                    selected: scope.data.date &&
                    date.isSame(scope.data.date, 'day'),
                };
            };



            scope.selectDate = function(date) {
                scope.data.date = date;
                ngModel.$setViewValue({
                    isMoment: scope.data.isMoment,
                    date: scope.data.date,
                });
                scope.dateSelected({date: scope.data.date});
            };

            scope.select = function(amount, unit) {
                scope.viewDate.set(unit, amount);
                scope.setContext('days');
            };

            scope.next = function() {
                if (scope.context == 'days') {
                    scope.viewDate.add(1, 'month');
                }
                else if(scope.context == 'month') {
                    scope.viewDate.add(1, 'year');
                }
                else if(scope.context == 'year') {
                scope.viewDate.add(20, 'years');
                }

            };

            scope.prev = function() {
                if (scope.context == 'days') {
                    scope.viewDate.subtract(1, 'month');
                }
                else if(scope.context == 'month') {
                    scope.viewDate.subtract(1, 'year');
                }
                else if(scope.context == 'year') {
                    scope.viewDate.subtract(20, 'years');
                }
            };

            scope.setContext = function(context) {
                scope.context = context;
            };

            ngModel.$formatters.push(function(modelValue) {
                return {
                    isMoment: moment.isMoment(modelValue),
                    date: modelValue && moment(modelValue),
                };
            });

            ngModel.$render = function() {
                scope.data = ngModel.$viewValue;
                setViewToDate(scope.data.date);
            };

            ngModel.$parsers.unshift(function(viewValue) {
                if (viewValue.isMoment) {
                    return viewValue.date;
                }
                return viewValue.date.format(valueFormat);
            });
        },
    };
});